export default {"src":"/_next/static/media/zoho.1aa98d30.svg","height":864,"width":2500,"blurWidth":0,"blurHeight":0};